import React, { useEffect } from 'react'
import { d2_catalog_1, d2_catalog_2 } from '../../../../escalas/dolor_2/dolor2_catalog';
import { Card } from 'antd';
import { useRef } from 'react';
import body from '../../../../assets/body.jpg'


// parent escalas emt.jsx

const ZONE_COLORS = [
  "rgba(220, 38, 38, 0.85)",
  "rgba(37, 99, 235, 0.85)",
  "rgba(22, 163, 74, 0.85)",
  "rgba(234, 88, 12, 0.85)",
  "rgba(147, 51, 234, 0.85)",
];

export default function DolorResults({ escalaDetails }) {

  // Selector canvas fixed resolution — coordinates are stored in this space
  const SELECTOR_W = 600;
  const SELECTOR_H = 625;

  // IMAGE
  const draw = (context, point, arrow, color = "rgba(255, 0, 0, 0.5)", index = null) => {
    // Match canvas internal resolution to its CSS display size
    context.canvas.width = context.canvas.offsetWidth;
    context.canvas.height = context.canvas.offsetHeight;

    // Scale factors from stored coordinate space to current display size
    const scaleX = context.canvas.width / SELECTOR_W;
    const scaleY = context.canvas.height / SELECTOR_H;

    context.clearRect(0, 0, context.canvas.width, context.canvas.height);

    if (point) {
      const px = point.x * scaleX;
      const py = point.y * scaleY;

      context.beginPath();
      context.arc(px, py, 12, 0, 2 * Math.PI);
      context.fillStyle = color;
      context.fill();
      context.strokeStyle = "white";
      context.lineWidth = 2;
      context.stroke();

      if (index !== null) {
        context.fillStyle = "white";
        context.font = "bold 13px Arial";
        context.textAlign = "center";
        context.textBaseline = "middle";
        context.fillText(index + 1, px, py);
      }
    }

    if (arrow && arrow.start && arrow.end) {
      const { start, end } = arrow;
      const sx = start.x * scaleX;
      const sy = start.y * scaleY;
      const ex = end.x * scaleX;
      const ey = end.y * scaleY;

      context.beginPath();
      context.moveTo(sx, sy);
      context.lineTo(ex, ey);
      context.strokeStyle = color;
      context.lineWidth = 2;
      context.stroke();

      // Draw arrowhead
      const angle = Math.atan2(ey - sy, ex - sx);
      context.beginPath();
      context.moveTo(ex, ey);
      context.lineTo(ex - 10 * Math.cos(angle - Math.PI / 6), ey - 10 * Math.sin(angle - Math.PI / 6));
      context.lineTo(ex - 10 * Math.cos(angle + Math.PI / 6), ey - 10 * Math.sin(angle + Math.PI / 6));
      context.closePath();
      context.fillStyle = color;
      context.fill();
    }
  };

  const PainZoneResults = ({ point, arrow, index = null }) => {
    const canvasRef = useRef(null);
    const color = index !== null ? ZONE_COLORS[index % ZONE_COLORS.length] : ZONE_COLORS[0];

    useEffect(() => {
      const canvas = canvasRef.current;
      const context = canvas.getContext("2d");
      const validArrow = arrow && arrow.start && arrow.end;
      draw(context, point, validArrow ? arrow : null, color, index);
    }, [point, arrow]);

    return (
      <div className="pain-zone-results">
        <br />
        <span className='desc' style={{ color }}>
          {index !== null ? `Zona ${index + 1} — dolor/irradiación` : 'Zona de dolor/irradiacion'}
        </span>
        <div style={{ position: 'relative', textAlign: 'center', marginBottom: '20px' }}>
          <img src={body} alt="Example" style={{ width: '100%' }} onLoad={() => {
            const canvas = canvasRef.current;
            const context = canvas.getContext("2d");
            draw(context, point, arrow, color, index);
          }} />
          <canvas ref={canvasRef} style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 2, borderRadius: 8, borderColor: '#6b809c' }} />
        </div>
      </div>
    );
  };
  // END OF IMAGE


  const RowCard = ({ labelKey, responseKey }) => {
    return <Card size='small'>
      <Card.Grid hoverable={false} style={{ width: '70%' }}>{d2_catalog_1[labelKey]}</Card.Grid>
      <Card.Grid hoverable={false} style={{ width: '30%' }}>{escalaDetails[responseKey]}</Card.Grid>
    </Card>
  }

  return (
    <div>
      <RowCard labelKey={0} responseKey='one' />
      <RowCard labelKey={1} responseKey='two' />
      <RowCard labelKey={2} responseKey='tree' />

      {/* New format: zonas array (N zones) */}
      {escalaDetails && escalaDetails.zonas && escalaDetails.zonas.length > 0
        ? escalaDetails.zonas.map((z, i) => (
            <PainZoneResults
              key={i}
              index={i}
              point={z.zona ? JSON.parse(z.zona) : null}
              arrow={z.irradia ? JSON.parse(z.irradia) : null}
            />
          ))
        /* Legacy format: single zona/irradia fields */
        : escalaDetails && escalaDetails.zona && (
            <PainZoneResults
              point={JSON.parse(escalaDetails.zona)}
              arrow={escalaDetails.irradia && JSON.parse(escalaDetails.irradia)}
            />
          )
      }

      {
        d2_catalog_2.map((pr, i) => {
          return <Card size='small'>
            <Card.Grid hoverable={false} style={{ width: '70%' }}>{pr}</Card.Grid>
            <Card.Grid hoverable={false} style={{ width: '30%' }}>{escalaDetails && escalaDetails['questions'][i]}</Card.Grid>
          </Card>
        })
      }

    </div>
  )
}
